import * as React from 'react';
import TextArea from '../../atoms/TextArea';
import { classes, style, stylesheet } from 'typestyle';
import Label from '../../atoms/Label';
import { borderPx, errMsgStyle, inputDefaultBorderColor, inputLineHeight, titleStyle } from '../../../styles/input';
import { smallStyle } from '../../../styles/text';
import { Black, Blood, Blue, GrayCream, White } from '../../../styles/colors';
class TextAreaInput extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            focused: false,
            rows: 1,
        };
        this.handleChangeFocus = (focused) => {
            this.setState({ focused });
            const { onFocus, onBlur } = this.props;
            if (focused) {
                onFocus && onFocus();
            }
            else {
                onBlur && onBlur();
            }
        };
        this.countRows = () => {
            if (!this.instance) {
                return 0;
            }
            const textArea = this.instance.querySelector('textarea');
            // Create a div with the same style as textarea
            // but without scrolls to count how many lines will it have
            const div = document.createElement('div');
            const textAreaStyle = getComputedStyle(textArea);
            div.style.width = `${textArea.clientWidth}px`;
            div.style.font = textAreaStyle.font;
            div.style.lineHeight = `${inputLineHeight}px`;
            div.style.padding = textAreaStyle.padding;
            div.innerHTML = (this.props.value || '').replace(/\n/g, '<br />&nbsp;');
            div.style.position = 'absolute';
            div.style.left = '-10000px';
            div.style.boxSizing = 'border-box';
            div.style.overflowWrap = 'break-word';
            div.style.height = 'auto';
            document.body.appendChild(div);
            const height = parseFloat(getComputedStyle(div).height);
            const linesCount = Math.floor(height / inputLineHeight);
            document.body.removeChild(div);
            return linesCount;
        };
        this.handleChange = (value) => {
            this.props.onChange(value);
        };
    }
    componentDidMount() {
        this.updateRows();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.updateRows();
        }
    }
    updateRows() {
        const rows = Math.max(this.countRows(), 1);
        const { maxRows = 10 } = this.props;
        this.setState({ rows: this.countRows() > maxRows ? maxRows : rows });
    }
    render() {
        const { name, value, title, placeholder, errorMessage, className, isInvalid = false, disabled = false, tabIndex, } = this.props;
        const { focused, rows } = this.state;
        const showPlaceholder = !focused && !value;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes('ta-textarea-input', className, textAreaInputContainerStyle.common, !errorMessage && textAreaInputContainerStyle.noErrorMessage, isInvalid && textAreaInputContainerStyle.error, focused && textAreaInputContainerStyle.focused, disabled && textAreaInputContainerStyle.disabled), ref: el => (this.instance = el) },
                title && !showPlaceholder && (React.createElement(Label, { title: title, className: classes(titleStyle.common, titleLabelStyle, smallStyle, focused && !isInvalid && titleStyle.focused, isInvalid && titleStyle.error) })),
                React.createElement(TextArea, { name: name, className: classes(textAreaStyle.common, title && !showPlaceholder && textAreaStyle.showTitle), isInvalid: isInvalid, disabled: disabled, placeholder: showPlaceholder ? placeholder : '', onChange: this.handleChange, onFocus: this.handleChangeFocus.bind(this, true), onBlur: this.handleChangeFocus.bind(this, false), value: value, rows: rows, tabIndex: tabIndex })),
            errorMessage && isInvalid && React.createElement(Label, { title: errorMessage, className: classes(errMsgStyle, smallStyle) })));
    }
}
const textAreaInputContainerStyle = stylesheet({
    common: {
        position: 'relative',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        background: White,
        padding: '0 0 10px 12px',
        borderRadius: 12,
        boxShadow: `0px 0px 0px ${borderPx}px ${inputDefaultBorderColor}`,
        boxSizing: 'border-box',
    },
    error: {
        boxShadow: `0px 0px 0px ${borderPx}px ${Blood} !important`,
    },
    noErrorMessage: {
        marginBottom: 14,
    },
    focused: {
        boxShadow: `0px 0px 0px ${borderPx}px ${Blue}`,
    },
    disabled: {
        background: `${GrayCream} !important`,
    },
});
const textAreaStyle = stylesheet({
    common: {
        width: '100%',
        minHeight: 34,
        boxSizing: 'border-box',
        color: Black,
        background: White,
        border: 0,
        caretColor: Blue,
        boxShadow: 'none !important',
        paddingRight: 12,
        marginTop: 12,
    },
    showTitle: {
        marginTop: '18px !important',
        minHeight: 26,
    },
});
const titleLabelStyle = style({
    top: 4,
    paddingTop: 0,
});
export default TextAreaInput;
//# sourceMappingURL=TextAreaInput.js.map